import { defineStore } from 'pinia'
import { type ISearchPageLink } from '@/stores/types'
import type { AssetStoryblok } from '@/storyblok/component-types-sb'
import { parseGlobalAlert } from '@/utils/sbDataParsers'
import type { IGlobalAlert, ICompactLinkData } from '@/components/main-header/types'
import type { LinkStoryblok } from '@/storyblok/component-types-sb'

export const useGlobalSettingsStore = defineStore('globalSettings', () => {
  // TODO: Implement the other links
  const createProfileLink = ref(null)
  const registerProfileLink = ref(null)
  const loginLink = ref<LinkStoryblok | null>(null)
  const globalAlert = ref<IGlobalAlert | null>(null)
  // const flightStatusLink = ref(null)
  // const searchLink = ref(null)
  const searchPageLink = ref<ISearchPageLink | null>(null)
  const headerFlightStatusLink = ref<ICompactLinkData | null>(null)
  const ogImage = ref<AssetStoryblok | null>(null)
  const aqfBackLink = ref<ICompactLinkData | null>(null)
  const hasDataLoaded = ref(false)

  const slug = '/data/global-settings'
  const resolveRelations = [
    'global-settings.createProfileLink',
    'global-settings.registerProfileLink',
    'global-settings.disclaimer',
    'global-settings.flightStatusLink',
    'global-settings.searchPageLink',
    'header-search.searchLink',
    'header-flight-status.link',
    'global-settings.loginLink',
    'global-settings.aqfBackLink'
  ]

  const showDisclaimer = (startDate: string, endDate: string) => {
    if (!startDate || !endDate) return false

    const dayjs = useDayjs()

    return dayjs().isAfter(startDate) && dayjs().isBefore(endDate)
  }

  const init = async () => {
    if (hasDataLoaded.value) {
      return
    }

    await useFetchDataFromStoryblok(slug, resolveRelations)
      .then(({ value: { content: data } }) => {
        searchPageLink.value = {
          placeholder: data?.searchPageLink.content.placeholder,
          ...getCompactLinkData(data?.searchPageLink.content?.searchLink?.content)
        }
        loginLink.value = data?.loginLink.content
        ogImage.value = data?.ogImage
        headerFlightStatusLink.value = getCompactLinkData(data?.flightStatusLink.content?.link?.content)
        aqfBackLink.value = getCompactLinkData(data?.aqfBackLink.content)
        // TODO: Handle other data
        if (data?.disclaimer && showDisclaimer(data?.startDate, data?.endDate)) {
          globalAlert.value = parseGlobalAlert(data?.disclaimer)
        }

        hasDataLoaded.value = true
      })
      .catch(() => {
        console.error('\x1b[33m%s\x1b[0m', '[Error]: Something went wrong. Please try again.')
      })
  }

  return {
    init,
    createProfileLink,
    registerProfileLink,
    globalAlert,
    loginLink,
    // flightStatusLink,
    searchPageLink,
    ogImage,
    // searchLink,
    headerFlightStatusLink,
    aqfBackLink
  }
})
